module.exports = __webpack_public_path__ + "static/media/casio-alarm-beep.f7809e6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/casio-alarm-beep.mp3
// module id = X2lX
// module chunks = 73